import React, { useState, useEffect, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import loadable from '@loadable/component';
import { PortalConfigContext, getLayoutContext } from '../../config/portal';
import {
  isMobileResolution as getIsMobileResolution,
  isSafelyInitializedWithLayout
} from '../../utils/commonHelper';
import { getCurrentLocale } from '../../utils/language';
import './styles.css';
import { definedValue } from '../../utils';

const Header = (props) => {
  const [isMobileResolution, setIsMobileResolution] = useState(
    isSafelyInitializedWithLayout('mobile')
  );
  // We need it on server side render.
  const [searchboxDesktop, setSearchSearchboxDesktop] = useState(true);
  const [isPageLoaded, setIsPageLoaded] = useState(false);

  // Context.
  const context = useContext(PortalConfigContext);
  const headerContext = definedValue(context.header, {});
  const navbarContext = getLayoutContext(headerContext?.layout, 'NavBar');
  // Features flags.
  const isTopNavigationV2Enabled = !!navbarContext?.enableTopNavigationV2;
  const usesOldHeader = context.supports?.oldHeader;    // [ATL-43] Needs to be places inside the <Header/> context.

  useEffect(() => {
    // Moved this set here as we only need to set this up when the page loads.
    setIsPageLoaded(true);
    const handleResize = () => setIsMobileResolution(getIsMobileResolution());
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const hydrationTimer = requestAnimationFrame(() => {
      setSearchSearchboxDesktop(!getIsMobileResolution());
    });

    return () => cancelAnimationFrame(hydrationTimer);
  }, []);

  useEffect(() => {
    setSearchSearchboxDesktop(!isMobileResolution);
  }, [isMobileResolution]);

  const currentLanguage = getCurrentLocale();
  const headerClassnames = useMemo(() => classnames('page-header-container', {
    'new-header': !usesOldHeader,
    'header-v2': isTopNavigationV2Enabled
  }), [context.supports]);
  const hdrPageClassnames = useMemo(() => classnames('page-header'), [isPageLoaded]);

  const layout = definedValue(headerContext.layout, []);
  const sharedProps = {
    ...props,
    currentLanguage,
    isPageLoaded,
    isTopNavigationV2Enabled,
    fullName: context.fullName,
    searchboxDesktop,
    isMobile: isMobileResolution
  };

  return (
    <div id="hdr-container" className={headerClassnames}>
      <div id="hdr-page-hdr" className={hdrPageClassnames}>
        {
          layout.map(element => {
            const Element = loadable(() => import(`./components/${element.name}`));
            return <Element key={`header-${element.name}`} {...sharedProps} context={{...element.context}}/>;
          })
        }
      </div>
    </div>
  );
};

Header.propTypes = {
  appBannerHeight: PropTypes.number,
  isWorking: PropTypes.bool,
  location: PropTypes.object,
  pageType: PropTypes.string
};

export default Header;
